let snapshotData = {}
export default snapshotData;


// WEBPACK FOOTER //
// ./src/scripts/data/snapshot-data.js